require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-team-كارولينا-وانيدا.json") })
        }
      }, "path---ar-eg-team-كارولينا-وانيدا");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-team-كارولينا-وانيدا!./.cache/json/ar-eg-team-كارولينا-وانيدا.json
// module id = 457
// module chunks = 231608221292675